// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__320pW","footerText":"Footer_footerText__2ACIE"};